import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CoreUiModule } from '../../core-ui/core-ui.module';
import { FolderTypeaheadComponent } from './FolderTypeahead.component';

@NgModule({
    imports: [CommonModule, FormsModule, CoreUiModule],
    declarations: [FolderTypeaheadComponent],
    exports: [FolderTypeaheadComponent],
    providers: []
})
export class FolderTypeaheadModule {}
